import { buildYup } from "schema-to-yup";

const customTests = {
	anyOf: (anyOfKeys) => [
		"anyOf",
		"Kein Feld gesetzt",
		function (values) {
			const res = anyOfKeys.find((key) => {
				return Array.isArray(values[key]) ? values[key].length : !!values[key];
			});
			return !!res;
		},
	],
};

const conditionFilter =
	(values) =>
	({ condition }) => {
		if (!condition || Object.values(condition).every((i) => i === "")) return true;
		const { conditionElementIdentifier, conditionMatches, extendedJsonCondition } = condition;
		const simpleCondition =
			conditionElementIdentifier && conditionElementIdentifier !== ""
				? {
						[conditionElementIdentifier]: {
							type: "string",
							matches: `^${conditionMatches}$`,
						},
					}
				: {};

		const { __CUSTOM_TESTS = [], ...extendedCondition } = extendedJsonCondition || {};

		let yupSchema = buildYup(
			{
				type: "object",
				properties: {
					...simpleCondition,
					...extendedCondition,
				},
			},

			{ errMessages: {} },
		);
		__CUSTOM_TESTS.forEach((conf) => {
			const testGenerator = customTests[conf.id];
			if (testGenerator) {
				yupSchema = yupSchema.test(...testGenerator(...conf.params));
			}
		});
		const res = yupSchema.isValidSync(values);
		return res;
	};

const getDisplayFields = (fields, values) => {
	const conditionFn = conditionFilter(values);
	return fields?.filter(conditionFn) || [];
};

export default getDisplayFields;
